"use client";

import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const x = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 25,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden
      style={{ scaleX: x }}
      className="fixed top-0 left-0 right-0 h-[2px] bg-gold origin-left z-[60]"
    />
  );
};
